export default __webpack_public_path__ + "static/media/hht1_ep05_timeline_q01_b.6402d6fe.png";